import React from 'react'

const WorkItems = ({item}) => {
  const [toggleState, setToggleState] = React.useState(0);
  const toggleTab = (index) => {
      setToggleState(index);     
  }
  return (
    <div className="work__card" key={item.id}>
        <img src={item.image} alt="" className="work__img" /> 
        <h3 className="work__title">{item.title}</h3>
        {/* <a href="#" className="work__button"> Demo 
            <i className="bx bx-right-arrow-alt work__button-icon"> </i>
        </a> */}
        <div >

                <span className="services__button" onClick={()=>toggleTab(1)}>View More
                    <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={()=>toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">{item.title}</h3>
                        <p className="services__modal-description">{item.info}</p>

                    </div>
                </div>

            </div>
    </div>
  )
}

export default WorkItems